import React, {
  useRef, useEffect, useState,
} from 'react';
import ReactDOM from 'react-dom';
import { useDispatch, useSelector } from 'react-redux';
import { commonActions } from '@/redux/modules';
import * as Styles from './Notifications.styles';
import { Toast } from '../Toast';
import { Alert } from 'gatorcomponents';


const timeOut = null;
const Notifications = () => {
  const notifications = useSelector(state => state.common.notifications);
  const dispatch = useDispatch();
  const domNode = document.body;
  const wrapperRef = useRef();
  const [maxWidth, setMaxWidth] = useState('513px');

  useEffect(() => {
    clearTimeout(timeOut);
    if (notifications.length) {
      setTimeout(() => {
        let lenght = 0;
        wrapperRef.current.childNodes.forEach((notification, index) => {
          const notficiationItem = notification;
          notficiationItem.style.bottom = `${lenght}px`;
          lenght += wrapperRef.current.childNodes[index].offsetHeight + 10;
        });
      }, 100);
    }
  }, [notifications, dispatch]);

  const removeNotification = (index) => {
    dispatch(commonActions.notifications.remove(index));
  };

  return ReactDOM.createPortal(
    <Styles.Wrapper
      ref={wrapperRef}
      maxWidth={maxWidth}
      hasToast={notifications.length && notifications[0].toast}
    >
      {notifications.map((notification, index) => {
        if (notification.maxWidth !== maxWidth) {
          setMaxWidth(notification.maxWidth);
        }

        if (notification.toast) {
          return (
            <Toast
              key={`notification-${notification.toast.title}`}
              onClose={() => removeNotification(index)}
              index={index}
              {...notification.toast}
            />
          );
        }

        return (
          <Styles.Notification
            index={index}
            data-testid={`notification-item-${index}`}
            maxWidth={notification.maxWidth}
            background={notification.backGround}
            key={`notification-${notification.label}`}
          >
            <Alert
              width="full"
              variant={notification.type}
              description={notification.label}
              onClose={() => removeNotification(index)}
            />
          </Styles.Notification>
        );
      })}
    </Styles.Wrapper>,
    domNode,
  );
};

export default Notifications;
